import request from '@/util/request';


export async function TradeBase(){
  return await request.get(`/api/trade_base`);
}

export async function TradeList({page}){
  return await request.get('/api/trade_list_by_page', {page: page});
}
